import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'
import _ from 'lodash'

export default function SettlementRequestItemBasicInfoComponent({
  handleInnerFormChange,
  selectedSettlementRequestItem,
  selectedParticipant,
  onClose,
  handleFormSubmit
}: any) {
  console.log('selectedSettlementRequestItem', selectedSettlementRequestItem)
  console.log('selectedParticipant', selectedParticipant)
  return (
    <>
      <div className="flex justify-center items-center w-[600px]">
        <div className="w-full max-w-lg p-2 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold mb-4 text-center">{  selectedSettlementRequestItem?.ParticipantId ? "Edit Settlement Request Item" : "Add New Settlement Request Item"}</h1>
          <div className="flex flex-col gap-4">          
                  <InputContainer
                    label="Participant"
                    name="ParticipantId"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedParticipant.ParticipantId',
                      })
                    }}
                    type="text"
                    value={selectedParticipant.ParticipantId}
                  />

                  <InputContainer
                    label="Status"
                    name="SettlementRequestItemStatusId"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'SettlementRequestItemStatusId',

                      })
                    }}
                    type="text"
                    value={selectedParticipant?.SettlementRequestItemStatusId}
                  />                                
                  <InputContainer
                    label="Recerence No"
                    name="ReferenceNo"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedParticipant.ReferenceNo',

                      })
                    }}
                    type="text"
                    value={selectedParticipant?.ReferenceNo}
                  />                                                                                 
                  <InputContainer
                    label="Settlement For"
                    name="SettlementFor"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedParticipant.SettlementFor',

                      })
                    }}
                    type="text"
                    value={selectedParticipant?.SettlementFor}
                  />                                                                                 
                  <InputContainer
                    label="Amount"
                    name="Amount"
                    onValueChange={(event: any) => {
                      handleInnerFormChange({
                        value: event.target.value,
                        path: 'selectedParticipant.Amount?.value',

                      })
                    }}
                    type="text"
                    value={selectedParticipant?.Amount?.value}
                  />                                
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              type="button"
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
              onClick={handleFormSubmit}
              type="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

    </>
  )
}